module.exports = __webpack_public_path__ + "static/media/defiville.a1e467a2.svg";